import styled from 'styled-components'

export const LargeV2 = styled.h3`
  font-size: ${({ theme: { fontSizes } }) => fontSizes.larger};
  text-align: ${({ align }) => align};
  color: ${({ theme: { colors }, color }) => colors[color]};
  margin: 0;
  margin: ${({ theme: { spaces } }) => spaces.large} 0;
`

export const MediumV2 = styled.p`
  font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};
  font-weight: bold;
  margin: 0;
  margin: ${({ theme: { spaces } }) => spaces.small} 0;
  color: ${({ theme: { colors }, color }) => colors[color]};
  text-align: ${({ align }) => align};
`
export const FooterV2 = styled.p`
  font-size: ${({ theme: { fontSizes } }) => fontSizes.extaMeduim};
  font-weight: bolder;
  margin: 0 0 0.6rem;
  color: ${({ theme: { colors } }) => colors.primary};
  text-align: ${({ align }) => align};
  @media (max-width: 850px) {
    flex: 1;
    align-self: center !important;
    margin: 0;
    padding-bottom: 0.3rem;
  }
`
export const SmallV2 = styled.p`
  margin: 0;
  color: ${({ theme: { colors }, color }) => colors[color]};
  text-align: ${({ align }) => align};
`
